// @file Composable to observe size changes of an element
import window, { ResizeObserver, ResizeObserverEntry } from '@@/bits/global'
import { Ref, onMounted, onUnmounted, unref } from 'vue'

type CallbackFunctionType = (element: HTMLElement, contentRect: DOMRectReadOnly) => void

export function useResizeObserver(maybeElement: HTMLElement | Ref<HTMLElement>, callback: CallbackFunctionType): void {
  let resizeObserver: ResizeObserver | null = null
  let observedElement: HTMLElement | null = null

  onMounted(() => {
    const element = unref(maybeElement)
    resizeObserver = new window.ResizeObserver((entries: ResizeObserverEntry[]): void => {
      entries.forEach((entry: ResizeObserverEntry): void => {
        callback(element, entry.contentRect)
      })
    })
    resizeObserver?.observe(element)
    observedElement = element
  })

  onUnmounted(() => {
    if (observedElement != null) {
      resizeObserver?.unobserve(observedElement)
      observedElement = null
    }
  })
}
